import { Phone, MapPin, Heart, Flame } from "lucide-react";
import { BRAND } from "../data/restaurant";
import { Reveal } from "./motion/Reveal";
import { BrushUnderline } from "./BrushHeading";
import logo from "../assets/pattista-logo.png";

export default function AboutUs() {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2">
        <Reveal>
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border-2 border-jet bg-cream px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] text-crimson shadow-hard-sm sm:text-sm">
            <Flame className="h-4 w-4" aria-hidden="true" />
            About Us
          </p>
          <h2 className="font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-jet sm:text-5xl">
            Three friends. <BrushUnderline>One big love.</BrushUnderline>
          </h2>
          <div className="mt-5 space-y-4 text-base font-medium leading-relaxed text-jet/80">
            <p>
              Three best friends, one big love for burgers and pasta, and a little madness in the
              kitchen — that&apos;s how Pattista was born!
            </p>
            <p>
              We&apos;re burger-and-pasta lovers who saw art in every bite and created our own
              flavour-packed recipes from scratch. No, we don&apos;t mix burgers and pasta; we give
              each its own spotlight! And the nachos? Well, one of us is that obsessed with nachos.
            </p>
            <p>
              From our fully inspected ghost kitchen to your doorstep, every order is freshly made
              and packed with a little piece of our hearts. We may not have dine-in seats, but
              there&apos;s always room for you in our family.
            </p>
          </div>
          <p className="mt-5 flex items-start gap-2 font-hand text-3xl font-bold leading-snug text-crimson">
            Because Pattista isn&apos;t just a brand — it&apos;s three best friends cooking up love,
            one bite at a time.
            <Heart className="mt-1 h-6 w-6 shrink-0 fill-crimson text-crimson" aria-hidden="true" />
          </p>
          <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:items-center">
            <a
              href={BRAND.phoneHref}
              data-testid="about-call-cta"
              className="inline-flex items-center justify-center gap-2 rounded-full border-[3px] border-jet bg-crimson px-7 py-3.5 font-display text-sm font-extrabold uppercase text-cream shadow-hard-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-hard"
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              {BRAND.phoneDisplay}
            </a>
            <p className="inline-flex items-center justify-center gap-2 text-sm font-bold text-jet/70">
              <MapPin className="h-4 w-4 shrink-0" aria-hidden="true" />
              {BRAND.address}
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="flex justify-center">
          <div className="relative rotate-2 rounded-[2.5rem] border-4 border-jet bg-amber p-10 shadow-hard transition-transform duration-300 hover:rotate-0 sm:p-14">
            <img src={logo} alt="Pattista logo" className="mx-auto w-56 drop-shadow-[0_16px_24px_rgba(84,32,27,0.4)] sm:w-72" />
            <p className="mt-6 text-center font-hand text-3xl font-bold text-jet">{BRAND.signoff}</p>
            <span className="absolute -right-3 -top-3 h-8 w-8 rotate-12 rounded-full border-[3px] border-jet bg-flame" aria-hidden="true" />
            <span className="absolute -bottom-3 -left-3 h-6 w-6 rounded-full border-[3px] border-jet bg-sunshine" aria-hidden="true" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
